<div class="basin-content-window basin-scroll-container-vertical">
  <div class="basin-display-flex basin-width-100">
    <div class="basin-display-flex basin-align-items-center basin-mb-4">
      <h4>Simulations</h4>
    </div>
  </div>

  <p-table styleClass="basin-table-height basin-mb-4" [value]="(simulationTrackers$ | async) || []"
    [columns]="tableColumns">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field" scope="col">
          <div class="p-d-flex p-ai-center">
            {{ col.label }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-simulationTracker let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" [class]="col.alignment">
          <span *ngIf="col.format === 'date'">
            {{ getValue(simulationTracker, col.field) | date : "MM-dd-yyyy" }}
          </span>
          <span *ngIf="!col.format">
            {{ getValue(simulationTracker, col.field) }}
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog></p-confirmDialog>
